import React from 'react';
import styled from 'styled-components';

import Icon from 'js/components/common/Icon';

const CheckIcon = styled(Icon)`
  margin-right: 0.25rem;
`;

const Container = styled.div`
  margin-top: 0.5rem;
  font-size: 0.8rem;
`;

export default () => (
  <Container>
    <CheckIcon name="check" /> Verified
  </Container>
);
